import router from "@app-router/index";
import useReservationStore from "@app-store/reservation";
import useSystemStore from "@app-store/system";
import useUserModule from "@app-store/user";
import { useObservability } from "@qamf/observability";
import { ref } from "vue";

import { type AppInsightsEvent } from "./observability-events";

export async function trackUserEvent(name: AppInsightsEvent, extraProps?: Record<string, any>, flush?: boolean) {
	const userModule = useUserModule();
	const systemModule = useSystemStore();
	const appRouter = ref(router);
	const reservationModule = useReservationStore();

	const properties: Record<string, any> = Object.assign(
		{},
		extraProps ?? {},
		{
			user: userModule.userData(),
			user_account: userModule.AccountInfo,
			user_customer: userModule.CustomerInfo
		},
		{
			routePath: appRouter.value.currentRoute.fullPath,
			routeName: appRouter.value.currentRoute.name
		},
		{
			...(reservationModule.reservationKey && { reservationKey: reservationModule.reservationKey }),
			...(reservationModule.reservationToken && { reservationToken: reservationModule.reservationToken })
		},
		{
			...(systemModule.functionalities && { functionalities: systemModule.functionalities }),
			...(systemModule.configurations && { configurations: systemModule.configurations })
		}
	);
	const { trackEvent } = useObservability();
	trackEvent(name, properties, flush);
}
